const AbsColor = {
    Blue1: '#002a4e',
    Blue2: '#001E40',
    Blue3: '#335572',
    Blue4: '#5E8AB4',

    Red1: '#DA1F33',
    Red2: '#B51227',
    Red3: '#DF444E',

    Yellow1: '#FFAD0A',
    Greeen1: '#4CA342',

    Gray1: '#f1f1f2',
    Gray2: '#524f4f',
    White1: '#FFFFFF'
};

export default AbsColor;
